import theme from '@styles/theme';
export default {
  fullModeContainer: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: 0,
    left: 0,
    background: theme.rawColors.neutralWhite,
    zIndex: theme.zIndex.documentHigh
  },
  fullModeContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    paddingBottom: '24px'
  },
  fullModeImg: {
    position: 'relative',
    width: '100%',
    margin: '60px auto 0',
    flexShrink: 0,
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 16px'
  },
  sliderContainer: {
    width: '100%',
    height: '100px',
    display: 'flex',
    position: 'relative',
    flexDirection: 'row',
    justifyContent: ['space-around', 'space-between'],
    alignItems: 'center',
    flexWrap: 'no-wrap',
    '.swiper-slide': {
      width: 'auto'
    }
  },
  sliderImg: {
    position: 'relative',
    height: '600',
    width: '100%',
    img: {
      objectFit: 'contain',
      objectPosition: 'center',
      margin: '0 auto',
      display: 'block'
    }
  },
  sliderThumb: {
    position: 'relative',
    height: '70px',
    width: 'auto',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    img: {
      objectFit: 'contain'
    }
  },
  closeButton: {
    position: 'absolute',
    top: 24,
    right: 24
  },
  sliderArrowButton: (dir: 'left' | 'right', hidden = false) => ({
    position: 'absolute',
    bottom: '40px',
    zIndex: hidden ? 0 : theme.zIndex.documentHigh,
    opacity: hidden ? 0 : theme.zIndex.documentUp,
    [dir]: '2%',
    width: '64px',
    height: '64px'
  })
};